import { validate } from 'uuid';
export const isSuggestionBoxRewriteHighlight = (suggestion) => {
    if (!validate(suggestion.id)) {
        return false;
    }
    return suggestion.type !== 'unknown';
};
